
module.exports = class ToolchestReviewerButton extends React.Component
  displayName: 'ToolchestReviewerButton'

  constructor: (props) ->
      super(props)
      # Expects: @props.
      # my_accepted_roles
      @state = { }

  render: =>

      if @props.tool_selected is 'reviewer_tools'
          card_className = 'card light_green'
      else
          card_className = 'card light_gray'


      <div className={card_className}>
        <div className="card-body">
            <h2 className="card-title">
                <button className='btn btn-primary'
                        onClick={ @props.onClick.bind(this, {tools: 'reviewer_tools', show_this: 'reviewer_tools'}) }>
                    reviewer tools
                </button>
            </h2>
            <p className="card-text">
                Use the reviewer tools.
            </p>
        </div>
      </div>
